import { Component } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CourseDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/CourseDto';
import { TeacherDto } from 'src/app/aplication/api/Manipulate/CoursesObjects/TeacherDto';
import { CourseService } from 'src/app/aplication/api/Services/CourseServices/Course.service';
import { TeacherService } from 'src/app/aplication/api/Services/CourseServices/TeacherService.service';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrl: './courses.component.scss'
})
export class CoursesComponent {
  showDialogAdd:boolean=false;
  showDialogTeachers:boolean=false;
  loaded:boolean=false;
  showCouseDetails:boolean=false;

  selectedCourse:CourseDto | null = null;
  listTeachers!:TeacherDto[];
  courses:CourseDto[]=[]

  animationNotFound: AnimationOptions = {
    path: 'assets/Animations/animationNotFoundPages.json',
  };
    
  constructor(
    protected _teacherService:TeacherService,
    protected _courseService:CourseService,
    protected _confirmationService:ConfirmationService,
    protected messageService:MessageService,
  ){
    this._teacherService.ListTeachers().subscribe(
      response=>{
        this.listTeachers = response;
      }
    )

    
  }

  ngOnInit(): void {

    this.GetCourses();
  }

  GetCourses(){
    this._courseService.ListCourses().subscribe(
      response=>{
          this.courses=response;
          this.loaded=true;
      }
    )
  }

  ShowCourseDetails(course:CourseDto){
    this.selectedCourse=course;
    this.showCouseDetails=true;
  }

  ConfirmDelete(event:any, course:CourseDto ){
    this._confirmationService.confirm({
      target: event.target as EventTarget,
      header: 'Confirmar exclusão?',
      message: 'Excluir este curso?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._courseService.Delete(course.id!).subscribe(response => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Exclusão concluída',
            life: 2000
          });

          this.courses = this.courses.filter(x=>x.id !=course.id);
        });
      },
      reject: () => {
        this.messageService.add({
          severity: 'warn',
          summary: 'Cancelado',
          detail: 'Operação cancelada.',
          life: 2000
        });
      }
    });
  }
  
}
